import { MobileLayout } from 'lib/mobileDesignSystem';
import Finance from 'pages/mobile/Finance';
import Confirming from 'pages/mobile/Finance/Confirming';
import ConfirmingApproval from 'pages/mobile/Finance/Confirming/ConfirmingApproval';
import ConfirmingOperationDetail from 'pages/mobile/Finance/Confirming/ConfirmingOperationDetail';
import ConfirmingDocuments from 'pages/mobile/Finance/Confirming/ConfirmingOperationDetail/Documents';
import ConfirmingEvaluationNodesPage from 'pages/mobile/Finance/Confirming/ConfirmingOperationDetail/EvaluationNodesPage';
import ConfirmingTabsView from 'pages/mobile/Finance/Confirming/ConfirmingTabsView';
import CreditLine from 'pages/mobile/Finance/CreditLine';
import CreditLineApproval from 'pages/mobile/Finance/CreditLine/CreditLineApproval';
import CreditLineOperationDetail from 'pages/mobile/Finance/CreditLine/CreditLineOperationDetail';
import CreditLineEvaluationNodesPage from 'pages/mobile/Finance/CreditLine/CreditLineOperationDetail/EvaluationNodesPage';
import CreditLineSubProducts from 'pages/mobile/Finance/CreditLine/CreditLineOperationDetail/SubProducts';
import CreditLineTabsView from 'pages/mobile/Finance/CreditLine/CreditLineTabsView';
import Factoring from 'pages/mobile/Finance/Factoring';
import FactoringApproval from 'pages/mobile/Finance/Factoring/FactoringApproval';
import FactoringOperationDetail from 'pages/mobile/Finance/Factoring/FactoringOperationDetail';
import FactoringDocuments from 'pages/mobile/Finance/Factoring/FactoringOperationDetail/Documents';
import EvaluationNodesPage from 'pages/mobile/Finance/Factoring/FactoringOperationDetail/EvaluationNodesPage';
import FactoringTabsView from 'pages/mobile/Finance/Factoring/FactoringTabsView';
import FinanceTabsView from 'pages/mobile/Finance/FinanceTabsView';
import Home from 'pages/mobile/Home';
import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

const MobileRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MobileLayout />}>
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="finance" element={<Finance />}>
            <Route index element={<FinanceTabsView />} />
            <Route path="factoring" element={<Factoring />}>
              <Route index element={<FactoringTabsView />} />
              <Route path=":id" element={<FactoringOperationDetail />} />
              <Route path=":id/approval" element={<FactoringApproval />} />
              <Route path=":id/documents" element={<FactoringDocuments />} />
              <Route
                path=":id/evaluation/:evaluationId/nodes"
                element={<EvaluationNodesPage />}
              />
            </Route>
            <Route path="confirming" element={<Confirming />}>
              <Route index element={<ConfirmingTabsView />} />
              <Route path=":id" element={<ConfirmingOperationDetail />} />
              <Route path=":id/approval" element={<ConfirmingApproval />} />
              <Route path=":id/documents" element={<ConfirmingDocuments />} />
              <Route
                path=":id/evaluation/:evaluationId/nodes"
                element={<ConfirmingEvaluationNodesPage />}
              />
            </Route>
            <Route path="credit-line" element={<CreditLine />}>
              <Route index element={<CreditLineTabsView />} />
              <Route path=":id" element={<CreditLineOperationDetail />} />
              <Route path=":id/approval" element={<CreditLineApproval />} />
              <Route
                path=":id/sub-products"
                element={<CreditLineSubProducts />}
              />
              <Route
                path=":id/evaluation/:evaluationId/nodes"
                element={<CreditLineEvaluationNodesPage />}
              />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MobileRoutes;
